import React from "react";

interface DetailPanelSkeletonProps {
  rows?: number; // Number of skeleton rows to display
}

/**
 * Skeleton loading component for detail panels (DealDetailPanel, ContactDetailPanel, AccountDetailPanel)
 * Displays animated placeholder rows while data is loading
 */
const DetailPanelSkeleton: React.FC<DetailPanelSkeletonProps> = ({ rows = 6 }) => {
  const buildSkeletonRow = (key: string) => (
    <div key={key} className="flex gap-1 items-start w-full">
      <div className="shrink-0 w-4 h-4 bg-gray-200 rounded animate-pulse" />
      <div className="shrink-0 w-[150px]">
        <div className="h-4 bg-gray-200 rounded w-20 animate-pulse" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="h-4 bg-gray-100 rounded w-32 animate-pulse" />
      </div>
    </div>
  );

  return (
    <div className="space-y-3">
      {Array.from({ length: rows }).map((_, idx) => buildSkeletonRow(`skeleton-${idx}`))}
    </div>
  );
};

export default DetailPanelSkeleton;
